jQuery(function(){

  // var $loginModal = $('#userLoginModal');
  var $logoutSuccessModal = $('#userLogoutSuccessModal');
  var $loginSuccessModal = $('#userLoginSuccessModal');
  var $loginModal = $('#userLoginModal');
  var $registerSuccessModal = $('#userRegisterSuccessModal');
  var $profileSuccessModal = $('#userProfileSuccessModal');
  var $deleteProfilSuccessModal = $('#deleteProfilSuccessModal');

  // var $forgotPasswordModal = $('#forgotPasswordModal');
  // var $userLogoutModal = $('#userLogoutModal');
  // var $resetPasswordModal = $('#resetPasswordModal');

  $logoutSuccessModal.on('hidden.bs.modal', function(){
    var target = $('.banner .brand').attr('href');
    window.location.href = target;
  });

  $deleteProfilSuccessModal.on('hidden.bs.modal', function(){
    var target = $('.banner .brand').attr('href');
    window.location.href = target;
  });

  $loginSuccessModal.on('hidden.bs.modal', function(){
    var currentUrl = window.location.href;
     window.location.href = currentUrl;
  });

  $loginModal.on('show.bs.modal', function(){
    $registerSuccessModal.modal('hide');
  });

  $profileSuccessModal.on('hidden.bs.modal', function(){
    var $this = $(this);
    var target = $this.find('.profile-page').attr('href');
    window.location.href = target;
  });

});



// WEBPACK FOOTER //
// ./scripts/autoload/_modal.js